import StateProfile from './StateProfile';

export default StateProfile;
